import { render, staticRenderFns } from "./product_details.vue?vue&type=template&id=e4ccb4ae"
import script from "./product_details.vue?vue&type=script&lang=js"
export * from "./product_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports